<template>
  <b-form-group
    :label="label"
  >
    <ValidationProvider
      v-slot="validationContext"
      :name="name"
      :rules="validate"
      :mode="validationMode"
    >
      <b-form-textarea
        v-model="_value"
        :name="name"
        :placeholder="placeholder"
        :state="getValidationState(validationContext)"
        type="text"
      >
      </b-form-textarea>
      <b-form-invalid-feedback
        :state="validationContext.errors.length === 0"
      >
        {{ validationContext.errors.join('. ') }}
      </b-form-invalid-feedback>
    </ValidationProvider>
  </b-form-group>
</template>

<script>
  export default {
    name: 'InputTextareaComponent',
    props: {
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: false,
        default: ''
      },
      placeholder: {
        type: String,
        required: false,
        default: ''
      },
      validate: {
        type: [String, Object],
        required: false,
        default: ''
      },
      value: {
        type: [String, Number],
        required: false,
        default: null,
      },
      validationMode: {
        type: String,
        required: false,
        default: 'passive'
      }
    },
    computed: {
      _value: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('update:value', value.trim())
          this.$emit('input', value.trim())
        }
      }
    },
    methods: {
      getValidationState({ validated, valid = null}) {
        return validated ? valid : null
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>